export const TOPIC_QUERY_KEYS = {
  /**
   * Key used across all traffic/topics queries
   */
  all: 'allTopicRequests'
};
